// CDD is stored as a number of dollars per year (null when blank).
export const cddToNumber = (v) => { const n = parseFloat(String(v ?? '').replace(/[^\d.]/g, '')); return Number.isFinite(n) ? n : null; };
